import {
  GET_NOTIFICATIONS,
} from '../actionTypes';

const initialState = {
  data: [],
  isLoading: false,
  error: false,
  message: '',
  currentPage: 0,
  totalPage: 1,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_NOTIFICATIONS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_NOTIFICATIONS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_NOTIFICATIONS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        data: payload.data.data?.data || [],
        currentPage: payload.data.data?.current_page,
        totalPage: payload.data.data?.total_page,
      };

    default:
      return state;
  }
}
